var render, staticRenderFns
import script from "./InfoTable.vue?vue&type=script&lang=ts"
export * from "./InfoTable.vue?vue&type=script&lang=ts"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=f0a00188&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a00188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a00188')) {
      api.createRecord('f0a00188', component.options)
    } else {
      api.reload('f0a00188', component.options)
    }
    
  }
}
component.options.__file = "src/components/Viewer/Info/InfoTable.vue"
export default component.exports